<template>
  <div class="my-account bg-grey h-100">
    <NavbarMain />
    <div class="row m-0 px-xl-5 px-1 py-3 bg-grey">
      <NavbarAccount class="col-xl-auto col-12 h-100" />
      <div class="col-xl col-md-12 px-xl-2 px-sm-0">
        <div class="row _container mx-auto">
          <div
            class="col-12 d-flex justify-content-between align-items-center my-4"
          >
            <h3>
              <b class="text-blue-light">
                Venta
                <span class="text-blue-shadow">#{{ buy.prettyID }}</span>
              </b>
            </h3>
            <h3>
              <b class="text-blue-light">CRR:</b>
              <span class="text-blue-shadow">SC${{ buy.crr.toFixed(2) }}</span>
            </h3>
            <h3>
              <b class="text-blue-light">Ganancia:</b>
              <span class="text-blue-shadow"
                >SC${{
                  (
                    buy.payment +
                    (buy.otherPayments
                      ? buy.otherPayments.reduce(
                          (acc, b) => acc + b.sacoin + b.financiamiento,
                          0
                        )
                      : 0)
                  ).toFixed(2)
                }}</span
              >
            </h3>
            <span class="d-flex align-items-center h6">
              <span class="material-icons mr-2">calendar_today</span>
              {{ dateToFullString(buy.creationDate) }}
            </span>
          </div>
          <div class="col-md-12 col-xl-8 p-0">
            <p class="alert alert-info">
              Estimados vendedores, el saldo de su venta,  se usara  para conversión a saldo disponible dentro de la plataforma de sistema Apple, recuerde conocer las políticas de cashback y usos de saldos como representante de la compañía.
            </p>
            <p class="alert alert-primary">
              Si su venta incluye pago de envío y mensajería, favor contactar a
              <a
                :href="`https://www.sistemaapple.com.mx/soporte/mis-chats?platform=TREID_BLUE&module=SALE&id=${$route.params.id}&prettyID=${buy.prettyID}`"
                class="font-weight-bold"
                >soporte</a
              >
              para la solicitud de la misma, indicando número de venta, peso en
              (kg) y dimensiones LxLxL (cm) para posterior ser enviada a su
              correo
            </p>
            <ProductsDetail :products="buy.products" :services="buy.services" />
            <ShippingDetail
              v-if="buy.shippingType != 2"
              :shippingType="buy.shippingType"
              :shippingPrice="buy.shippingPrice"
              v-on:handleClickSetShipping="handleClickSetShipping"
            />
            <PaymentDetail
              :products="buy.products"
              :sacoin="buy.sacoin"
              :otherPayments="buy.otherPayments"
              :financiamiento="buy.financiamiento"
              :shippingPrice="buy.shippingPrice"
            />
            <!--  /* ESTADO DE ENVIO PRODUCTO */  v-if="buy.products.length"  -->
            <div class="shadow-blue-sm rounded bg-white px-3 mt-3 pt-3 mb-3">
              <h5 class="d-flex align-items-center mb-5">
                <span class="material-icons mr-2">local_shipping</span> Estado
                de la compra
              </h5>
              <div class="pb-4" v-if="buy.creationDate != ''">
                <div
                  v-if="
                    buy.shippingType == 0 ||
                    buy.shippingType == 3 ||
                    buy.shippingType == 4
                  "
                >
                  <div class="state_shipping row">
                    <div class="col-6 pt-4 text-right">
                      {{ dateToString(buy.creationDate) }}
                    </div>
                    <div
                      class="col border-left"
                      style="border-left: 6px solid #28a745 !important"
                    >
                      <span
                        class="material-icons text-success"
                        style="position: relative; left: -31px; top: -2px"
                      >
                        lens
                      </span>
                      <h6 class="mb-4">En proceso de aceptación</h6>
                    </div>
                  </div>

                  <div
                    class="state_shipping row"
                    v-if="existState('IN_PREPARATION')"
                  >
                    <div class="col-6 pt-4 text-right">
                      {{ dateToString(getDateState("IN_PREPARATION")) }}
                    </div>
                    <div
                      class="col border-left"
                      style="border-left: 6px solid #28a745 !important"
                    >
                      <span
                        class="material-icons text-success"
                        style="position: relative; left: -31px; top: -2px"
                      >
                        lens
                      </span>
                      <h6 class="mb-4">En preparación</h6>
                    </div>
                  </div>

                  <div
                    class="state_shipping row"
                    v-if="existState('IN_TRAVEL')"
                  >
                    <div class="col-6 pt-4 text-right">
                      {{ dateToString(getDateState("IN_TRAVEL")) }}
                    </div>
                    <div
                      class="col border-left"
                      style="border-left: 6px solid #28a745 !important"
                    >
                      <span
                        class="material-icons text-success"
                        style="position: relative; left: -31px; top: -2px"
                      >
                        lens
                      </span>
                      <h6 class="mb-4">En viaje</h6>
                      <span
                        >Código de seguimiento:
                        {{ getInfoState("IN_TRAVEL") }}</span
                      >
                    </div>
                  </div>

                  <div class="state_shipping row" v-if="lastState('IN_TRAVEL')">
                    <div class="col-6 pt-4 text-right"></div>
                    <div
                      class="col border-left"
                      style="border-left: 6px solid #6c757d !important"
                    >
                      <span
                        class="material-icons text-success"
                        style="position: relative; left: -31px; top: -2px"
                      >
                        lens
                      </span>
                      <h6 class="mb-4">Entregado</h6>
                      <span
                        >Esperando a que el comprador reciba el producto</span
                      >
                    </div>
                  </div>

                  <div
                    class="state_shipping row"
                    v-if="existState('DELIVERED')"
                  >
                    <div class="col-6 pt-4 text-right">
                      {{ dateToString(getDateState("DELIVERED")) }}
                    </div>
                    <div
                      class="col border-left"
                      style="border-left: 6px solid #28a745 !important"
                    >
                      <span
                        class="material-icons text-success"
                        style="position: relative; left: -31px; top: -2px"
                      >
                        lens
                      </span>
                      <h6 class="mb-4">Entregado</h6>
                    </div>
                  </div>
                  <div
                    class="state_shipping row"
                    v-if="existState('CANCEL_BY_SELLER')"
                  >
                    <div class="col-6 pt-4 text-right">
                      {{ dateToString(getDateState("CANCEL_BY_SELLER")) }}
                    </div>
                    <div class="col border-left-danger">
                      <span
                        class="material-icons text-danger"
                        style="position: relative; left: -31px; top: -2px"
                      >
                        lens
                      </span>
                      <h6 class="mb-4">Cancelado por el vendedor</h6>
                    </div>
                  </div>
                  <div
                    class="state_shipping row"
                    v-if="existState('CANCEL_BY_SELLER')"
                  >
                    <div class="col-6"></div>
                    <div class="col">
                      <div style="position: relative; left: -25px; top: -2px">
                        <span class="material-icons text-danger"> lens </span>
                      </div>
                    </div>
                    <div class="col-12">
                      <h6 class="text-center">Compra cancelada</h6>
                    </div>
                  </div>
                  <div class="state_shipping row" v-if="lastState('DELIVERED')">
                    <div class="col-6"></div>
                    <div class="col">
                      <div style="position: relative; left: -25px; top: -2px">
                        <span class="material-icons text-success"> lens </span>
                        <h6 style="position: relative; left: -4px">Listo</h6>
                      </div>
                    </div>
                  </div>
                  <div
                    class="state_shipping row"
                    v-if="lastState('NO_STATE_NAME')"
                  >
                    <div class="col-6"></div>
                    <div class="col">
                      <div style="position: relative; left: -25px; top: -2px">
                        <span class="material-icons text-secondary">
                          lens
                        </span>
                      </div>
                    </div>
                    <div class="col-12 text-center">
                      <h6>Tienes stock de estos productos para vender?</h6>
                      <span
                        class="btn btn-danger mx-2"
                        @click="handleSetState('CANCEL_BY_SELLER', '')"
                        >Cancelar venta</span
                      >
                      <span
                        @click="handleSetState('IN_PREPARATION', '')"
                        class="btn btn-treid mx-2"
                        >Si, puedo preparar la venta</span
                      >
                    </div>
                  </div>
                  <div
                    class="state_shipping row"
                    v-if="lastState('IN_PREPARATION')"
                  >
                    <div class="col-6"></div>
                    <div class="col">
                      <div style="position: relative; left: -25px; top: -2px">
                        <span class="material-icons text-secondary">
                          lens
                        </span>
                      </div>
                    </div>
                    <div class="col-12 text-center">
                      <h6>Ya despachaste la venta?</h6>
                      <div class="form-inline d-flex justify-content-center">
                        <input
                          type="text"
                          class="form-control m-1"
                          placeholder="Empresa de envío"
                          v-model="inputs.empresaEnvio"
                        />
                        <input
                          type="text"
                          class="form-control m-1"
                          placeholder="Codigo de seguimiento"
                          v-model="inputs.codigoSeguimiento"
                        />
                        <span
                          @click="handleSetInTravel()"
                          class="btn btn-treid mx-2"
                          >Aceptar</span
                        >
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-12 text-center mt-3"
                    v-show="lastState('REMEMBER_DELIVERED')"
                  >
                    <p class="alert-danger py-2">
                      se ha solicitado al comprador la indicación de recepción
                    </p>
                  </div>
                  <div
                    class="col-12 text-center mt-3"
                    v-if="lastState('IN_TRAVEL')"
                  >
                    <span
                      v-show="!isSending"
                      @click="handleSetState('REMEMBER_DELIVERED', '')"
                      class="btn btn-warning"
                      >Solicitar al comprador indicación de recepción</span
                    >
                    <span v-show="isSending" class="btn btn-warning"
                      >Enviando...</span
                    >
                  </div>
                  <h6
                    v-if="buy.claim"
                    class="alert alert-warning text-center mt-5"
                  >
                    Reclamo iniciado
                  </h6>
                </div>
                <div v-if="buy.shippingType == 1">
                  <div class="state_shipping row">
                    <div class="col-6 pt-4 text-right">
                      {{ dateToString(buy.creationDate) }}
                    </div>
                    <div class="col border-left-success">
                      <span
                        class="material-icons text-success"
                        style="position: relative; left: -31px; top: -2px"
                      >
                        lens
                      </span>
                      <h6 class="mb-4">En proceso de aceptación</h6>
                    </div>
                  </div>

                  <div class="state_shipping row">
                    <div class="col-6 pt-4 text-right">
                      <span v-if="existState('IN_PREPARATION')">{{
                        dateToString(getDateState("IN_PREPARATION"))
                      }}</span>
                    </div>
                    <div
                      class="col"
                      :class="
                        existState('IN_PREPARATION')
                          ? 'border-left-success'
                          : 'border-left-secondary'
                      "
                    >
                      <span
                        class="material-icons"
                        :class="
                          existState('IN_PREPARATION')
                            ? 'text-success'
                            : 'text-secondary'
                        "
                        style="position: relative; left: -31px; top: -2px"
                      >
                        lens
                      </span>
                      <h6 class="mb-4">En preparación</h6>
                    </div>
                  </div>

                  <div class="state_shipping row">
                    <div class="col-6 pt-4 text-right">
                      <span v-if="existState('IN_TRAVEL')">{{
                        dateToString(getDateState("IN_TRAVEL"))
                      }}</span>
                    </div>
                    <div
                      class="col"
                      :class="
                        existState('IN_TRAVEL')
                          ? 'border-left-success'
                          : 'border-left-secondary'
                      "
                    >
                      <span
                        class="material-icons"
                        :class="
                          existState('IN_TRAVEL')
                            ? 'text-success'
                            : 'text-secondary'
                        "
                        style="position: relative; left: -31px; top: -2px"
                      >
                        lens
                      </span>
                      <h6 class="mb-4">En viaje</h6>
                      <span
                        >Código de seguimiento:
                        {{ getInfoState("IN_TRAVEL") }}</span
                      >
                    </div>
                  </div>

                  <div class="state_shipping row">
                    <div class="col-6 pt-4"></div>
                    <div
                      class="col"
                      :class="
                        existState('DELIVERED')
                          ? 'border-left-success'
                          : 'border-left-secondary'
                      "
                    >
                      <span
                        class="material-icons"
                        :class="
                          existState('IN_TRAVEL')
                            ? 'text-success'
                            : 'text-secondary'
                        "
                        style="position: relative; left: -31px; top: -2px"
                      >
                        lens
                      </span>
                      <h6 class="mb-4">Entregado</h6>
                    </div>
                  </div>
                  <div class="state_shipping row" v-if="lastState('DELIVERED')">
                    <div class="col-6"></div>
                    <div class="col">
                      <div style="position: relative; left: -25px; top: -2px">
                        <span class="material-icons text-success"> lens </span>
                        <h6 style="position: relative; left: -4px">Listo</h6>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="buy.shippingType == 2">
                  <div class="state_shipping row">
                    <div class="col-6 pt-4 text-right">
                      {{ dateToString(buy.creationDate) }}
                    </div>
                    <div
                      class="col border-left"
                      style="border-left: 6px solid #28a745 !important"
                    >
                      <span
                        class="material-icons text-success"
                        style="position: relative; left: -31px; top: -2px"
                      >
                        lens
                      </span>
                      <h6 class="mb-4">En proceso de aceptación</h6>
                    </div>
                  </div>

                  <div
                    class="state_shipping row"
                    v-if="existState('IN_PREPARATION')"
                  >
                    <div class="col-6 pt-4 text-right">
                      {{ dateToString(getDateState("IN_PREPARATION")) }}
                    </div>
                    <div
                      class="col border-left"
                      style="border-left: 6px solid #28a745 !important"
                    >
                      <span
                        class="material-icons text-success"
                        style="position: relative; left: -31px; top: -2px"
                      >
                        lens
                      </span>
                      <h6 class="mb-4">En preparación</h6>
                    </div>
                  </div>

                  <div
                    class="state_shipping row"
                    v-if="existState('IN_TRAVEL')"
                  >
                    <div class="col-6 pt-4 text-right">
                      {{ dateToString(getDateState("IN_TRAVEL")) }}
                    </div>
                    <div
                      class="col border-left"
                      style="border-left: 6px solid #28a745 !important"
                    >
                      <span
                        class="material-icons text-success"
                        style="position: relative; left: -31px; top: -2px"
                      >
                        lens
                      </span>
                      <h6 class="mb-4">En viaje</h6>
                      <span
                        >Código de seguimiento:
                        {{ getInfoState("IN_TRAVEL") }}</span
                      >
                    </div>
                  </div>

                  <div class="state_shipping row" v-if="lastState('IN_TRAVEL')">
                    <div class="col-6 pt-4 text-right"></div>
                    <div
                      class="col border-left"
                      style="border-left: 6px solid #6c757d !important"
                    >
                      <span
                        class="material-icons text-success"
                        style="position: relative; left: -31px; top: -2px"
                      >
                        lens
                      </span>
                      <h6 class="mb-4">Entregado</h6>
                      <span
                        >Esperando a que el comprador reciba el producto</span
                      >
                    </div>
                  </div>

                  <div
                    class="state_shipping row"
                    v-if="existState('DELIVERED')"
                  >
                    <div class="col-6 pt-4 text-right">
                      {{ dateToString(getDateState("DELIVERED")) }}
                    </div>
                    <div
                      class="col border-left"
                      style="border-left: 6px solid #28a745 !important"
                    >
                      <span
                        class="material-icons text-success"
                        style="position: relative; left: -31px; top: -2px"
                      >
                        lens
                      </span>
                      <h6 class="mb-4">Entregado</h6>
                    </div>
                  </div>
                  <div
                    class="state_shipping row"
                    v-if="existState('CANCEL_BY_SELLER')"
                  >
                    <div class="col-6 pt-4 text-right">
                      {{ dateToString(getDateState("CANCEL_BY_SELLER")) }}
                    </div>
                    <div class="col border-left-danger">
                      <span
                        class="material-icons text-danger"
                        style="position: relative; left: -31px; top: -2px"
                      >
                        lens
                      </span>
                      <h6 class="mb-4">Cancelado por el vendedor</h6>
                    </div>
                  </div>
                  <div
                    class="state_shipping row"
                    v-if="existState('CANCEL_BY_SELLER')"
                  >
                    <div class="col-6"></div>
                    <div class="col">
                      <div style="position: relative; left: -25px; top: -2px">
                        <span class="material-icons text-danger"> lens </span>
                      </div>
                    </div>
                    <div class="col-12">
                      <h6 class="text-center">Compra cancelada</h6>
                    </div>
                  </div>
                  <div class="state_shipping row" v-if="lastState('DELIVERED')">
                    <div class="col-6"></div>
                    <div class="col">
                      <div style="position: relative; left: -25px; top: -2px">
                        <span class="material-icons text-success"> lens </span>
                        <h6 style="position: relative; left: -4px">Listo</h6>
                      </div>
                    </div>
                  </div>
                  <div
                    class="state_shipping row"
                    v-if="lastState('NO_STATE_NAME')"
                  >
                    <div class="col-6"></div>
                    <div class="col">
                      <div style="position: relative; left: -25px; top: -2px">
                        <span class="material-icons text-secondary">
                          lens
                        </span>
                      </div>
                    </div>
                    <div class="col-12 text-center">
                      <h6>Tienes stock de estos productos para vender?</h6>
                      <span
                        class="btn btn-danger mx-2"
                        @click="handleSetState('CANCEL_BY_SELLER', '')"
                        >Cancelar venta</span
                      >
                      <span
                        @click="handleSetState('IN_PREPARATION', '')"
                        class="btn btn-treid mx-2"
                        >Si, puedo preparar la venta</span
                      >
                    </div>
                  </div>
                  <div
                    class="state_shipping row"
                    v-if="lastState('IN_PREPARATION')"
                  >
                    <div class="col-6"></div>
                    <div class="col">
                      <div style="position: relative; left: -25px; top: -2px">
                        <span class="material-icons text-secondary">
                          lens
                        </span>
                      </div>
                    </div>
                    <div class="col-12 text-center">
                      <h6>Esperando a que coordinen la compra</h6>
                      <div class="form-inline d-flex justify-content-center">
                        <p></p>
                      </div>
                    </div>
                  </div>
                  <div class="state_shipping row" v-if="lastState('PICKUP')">
                    <div class="col-6"></div>
                    <div class="col">
                      <div style="position: relative; left: -25px; top: -2px">
                        <span class="material-icons text-success"> lens </span>
                      </div>
                    </div>
                    <div class="col-12 text-center">
                      <h6>Listo</h6>
                      <div class="form-inline d-flex justify-content-center">
                        <p></p>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-12 text-center mt-3"
                    v-show="lastState('REMEMBER_DELIVERED')"
                  >
                    <p class="alert-danger py-2">
                      se ha solicitado al comprador la indicación de recepción
                    </p>
                  </div>
                  <div
                    class="col-12 text-center mt-3"
                    v-if="lastState('IN_TRAVEL')"
                  >
                    <span
                      v-show="!isSending"
                      @click="handleSetState('REMEMBER_DELIVERED', '')"
                      class="btn btn-warning"
                      >Solicitar al comprador indicación de recepción</span
                    >
                    <span v-show="isSending" class="btn btn-warning"
                      >Enviando...</span
                    >
                  </div>
                  <h6
                    v-if="buy.claim"
                    class="alert alert-warning text-center mt-5"
                  >
                    Reclamo iniciado
                  </h6>
                </div>
              </div>
            </div>
            <!--  /* ESTADO DE ENVIO SERVICIO */  -->
          </div>
          <div class="col-xl-4 px-0 px-xl-3 col-12 pt-xl-0 pt-5">
            <div
              class="shadow-blue-sm rounded bg-white p-3 mt-3"
              v-if="existState('DELIVERED')"
            >
              <h5 class="d-flex justify-content-between mb-4">
                <span
                  ><span class="material-icons mr-2">request_quote</span>Balance
                </span>
                <router-link :to="{ name: 'MyBalance' }" class="btn btn-treid"
                  >retirar saldo</router-link
                >
              </h5>
              <div class="px-4 py-1">
                <p>
                  <b>Ganancia:</b> SC${{
                    (
                      buy.payment +
                      buy.otherPayments.reduce(
                        (acc, b) => acc + b.sacoin + b.financiamiento,
                        0
                      )
                    ).toFixed(2)
                  }}
                </p>
                <p><b>CRR generado:</b> SC${{ buy.crr.toFixed(2) }}</p>
              </div>
            </div>
            <div class="alert alert-info">
              <span class="material-icons position-absolute">privacy_tip</span
              ><span class="pl-4"
                >si tienes una consulta,
                <a
                  :href="`https://www.sistemaapple.com.mx/soporte/mis-chats?platform=TREID_BLUE&module=SALE&id=${$route.params.id}&prettyID=${buy.prettyID}`"
                  class="font-weight-bold"
                  >click aquí</a
                >
                para más ayuda</span
              >
            </div>

            <div
              class="shadow-blue-sm rounded bg-white p-3 mt-3"
              v-if="existState('IN_PREPARATION') && buy.shippingType != 2"
            >
              <h5 class="d-flex align-items-center mb-4">
                <span class="material-icons mr-2">flight_takeoff</span>Datos del
                envío
              </h5>
              <div
                class="px-4 py-1"
                v-for="info in buy.shippingInfo"
                :key="info.key"
              >
                <div class="">
                  <b>{{ info.key }}:</b>
                  <span class="pl-2">{{ info.value }}</span>
                </div>
              </div>
            </div>
            <div class="shadow-blue-sm rounded bg-white p-3">
              <h5 class="d-flex align-items-center">
                <span class="material-icons mr-2">account_circle</span>Comprador
              </h5>
              <div class="row m-0 mt-4">
                <div class="col-2">
                  <span class="material-icons mr-2" style="font-size: 50px"
                    >account_circle</span
                  >
                </div>
                <div class="col-10 d-flex align-items-center">
                  <h5 class="text-capitalize">
                    {{ buy.buyer.username }} ({{ buy.countBuys }} compras)
                  </h5>
                </div>
              </div>
              <hr />
              <div v-if="existState('IN_PREPARATION')">
                <h5 class="d-flex align-items-center mt-5">
                  <span class="material-icons mr-2">contacts</span>Contacto
                </h5>
                <h6 class="ml-md-3 ml-5">Correo: {{ buy.buyer.email }}</h6>
                <h6 class="ml-md-3 ml-5">Teléfono: -</h6>
                <h6 class="ml-md-3 ml-5">Nombre: {{ buy.buyer.fullName }}</h6>
                <h6 class="ml-md-3 ml-5">DNI: {{ buy.buyer.dni }}</h6>
              </div>
            </div>
            <div class="shadow-blue-sm rounded bg-white p-3 mt-3">
              <h5 class="d-flex align-items-center mb-4">
                <span class="material-icons mr-2">chat</span>
                conversación
              </h5>
              <div class="text-center">
                <span class="btn btn-treid btn-block" @click="handleShowChat"
                  >Ver chat</span
                >
              </div>
            </div>
            <div class="shadow-blue-sm rounded bg-white p-3 mt-3" v-show="['test10', 'test', 'admin', 'sistapp', 'Sistapp'].includes(buy.seller.username)">
              <div class="row">
                <div class="col-12 mb-3">
                  <p>Motivo por el cual pediras mas dinero al comprador</p>
                  <textarea
                    v-model="message"
                    type="text"
                    class="form-control"
                    rows="4"
                    placeholder="Ej.: Necesito $MXN 400 para el envío"
                  ></textarea>
                </div>
                <div class="col-12 mt-3">
                  <select class="form-control" v-model="currency">
                    <option
                      v-for="change in changes"
                      :key="'change-' + change.currency"
                      :value="change.currency"
                      :selected="change.currency == currency"
                    >
                      {{ change.currency }}
                    </option>
                  </select>
                </div>
                <div class="col-12 mt-3">
                  <p>Monto a pedir (${{ currency }})</p>
                  <input
                    type="number"
                    class="form-control"
                    :placeholder="`Monto a pedir ($${currency})`"
                    v-model="shippingPriceNew"
                  />
                </div>
                <div class="col-12 mt-3">
                  <p>Monto final ($SC)</p>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Monto final ($SC)"
                    :value="publishedShippingPrice"
                    disabled
                  />
                </div>
              </div>
              <div class="text-center pt-3">
                <span
                  v-show="!onLoadSetShipping"
                  class="btn btn-treid"
                  @click="handleClickSetShipping"
                  >Pedir dinero</span
                >
                <span v-show="onLoadSetShipping" class="btn btn-treid"
                  >Cargando...</span
                >
                <p v-show="setShippingError" class="text-danger mt-3">Por favor escribe un motivo y un monto a pedir</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalChatSale
      v-if="buy._id"
      :visible="modalChatSale.visible"
      v-on:close="handleCloseChat()"
      :buy="buy._id"
      :claim="buy.claim"
    />
  </div>
</template>

<script>
import Configs from "@/configs/configs";
import { mapState } from "vuex";
import NavbarMain from "@/components/NavbarMain.vue";
import NavbarAccount from "@/components/account/NavbarAccount.vue";
import ModalChatSale from "@/components/modals/ModalChatSale";
import Api from "../../tools/Api2";
import { CONSTANT_BUY } from "../../configs/contants";
import PaymentDetail from "../../components/buy/PaymentDetail.vue";
import ShippingDetail from "../../components/buy/ShippingDetail.vue";
import ProductsDetail from "../../components/buy/ProductsDetail.vue";
import { LC } from "../../tools/exchange";
export default {
  name: "MySale",
  components: {
    NavbarMain,
    NavbarAccount,
    ModalChatSale,
    PaymentDetail,
    ShippingDetail,
    ProductsDetail,
  },
  data() {
    return {
      onLoadSetShipping: false,
      setShippingError: false,
      currency: "MXN",
      shippingPriceNew: 0,
      localCurrency: null,
      message: "",
      modalChatSale: {
        visible: false,
      },
      url_base: Configs.API.BASE,
      buy: {
        crr: 0,
        payment: 0,
        buyer: { _id: "", username: "" },
        creationDate: "",
        financiamiento: 0,
        products: [],
        sacoin: 0,
        seller: { _id: "", username: "" },
        shippingInfo: [],
        shippingPrice: 0,
        state: [],
        claim: false,
      },
      inputs: {
        codigoSeguimiento: "",
        empresaEnvio: "",
      },
      url: Configs.API.BASE,
      isSending: false,
    };
  },
  methods: {
    async handleClickSetShipping() {
      if(!this.message || !this.shippingPriceNew) {
        this.setShippingError = true;
        return;
      }
      this.setShippingError = false;
      const chat = await Api("chat/buy")
        .get(this.buy._id)
        .then((res) => res.chat._id);
      if (!chat) {
        return;
      }
      this.onLoadSetShipping = true;
      Api("chat")
        .patch(chat, {
          message: this.message,
          amount: this.shippingPriceNew,
          method: "ASK_MONEY",
          currency: this.currency,
        })
        .finally(() => {
          this.onLoadSetShipping = false;
          this.modalChatSale.visible = true;
          this.buy._id = 0;
          Api("buy")
            .get(this.$route.params.id)
            .then((res) => {
              if (res.buy.seller._id != this.auth.id) {
                return this.$router.push({ name: "Home" });
              }

              res.buy.shippingTypeName =
                CONSTANT_BUY.shippingType[res.buy.shippingType];
              this.buy.countSells = res.count.sells;
              this.buy = res.buy;
            });
        });
    },
    handleShowChat() {
      this.modalChatSale.visible = true;
    },
    handleCloseChat() {
      this.modalChatSale.visible = false;
    },
    handleSetInTravel() {
      this.handleSetState(
        "IN_TRAVEL",
        `${this.inputs.codigoSeguimiento} (${this.inputs.empresaEnvio})`
      );
    },
    handleSetState(name, info) {
      this.isSending = true;
      Api(`buy/state/${this.buy._id}`)
        .post({ name, info })
        .then((res) => {
          this.buy.state = res.state;
          this.isSending = false;
        })
        .catch(() => {
          this.isSending = false;
        });
    },
    getInfoState(name) {
      let buy = this.buy.state.find((x) => x.name == name);
      return buy ? buy.info : "";
    },
    getDateState(name) {
      let buy = this.buy.state.find((x) => x.name == name);
      return buy.date;
    },
    lastState(name) {
      return this.buy.state.length
        ? this.buy.state[this.buy.state.length - 1].name == name
        : "NO_STATE_NAME" == name;
    },
    existState(name) {
      return this.buy.state.find((x) => x.name == name);
    },
    dateToString(str) {
      let date = new Date(str);
      return `${date.getDate()}/${
        (date.getMonth() < 10 ? "0" : "") + date.getMonth()
      }/${date.getFullYear()}`;
    },
    dateToFullString(str) {
      let date = new Date(str);
      return `${date.getDate()}.${
        (date.getMonth() < 10 ? "0" : "") + date.getMonth()
      }.${date.getFullYear()} a las ${date.getHours()}:${date.getMinutes()}`;
    },
  },
  computed: {
    ...mapState(["auth"]),
    publishedShippingPrice: function () {
      if (this.localCurrency)
        return (
          "$SC " +
          this.localCurrency
            .localToSC({
              price: this.shippingPriceNew,
              currency: this.currency,
            })
            .toFixed(2)
        );
      return -1;
    },
    changes: function () {
      if (!this.localCurrency) return [];
      return this.localCurrency.getList();
    },
  },
  created: async function () {
    LC.new().then((localCurrency) => {
      this.localCurrency = localCurrency;
    });
    Api("buy")
      .get(this.$route.params.id)
      .then((res) => {
        if (res.buy.seller._id != this.auth.id) {
          return this.$router.push({ name: "Home" });
        }

        res.buy.shippingTypeName =
          CONSTANT_BUY.shippingType[res.buy.shippingType];
        this.buy.countSells = res.count.sells;
        this.buy = res.buy;
      });
  },
};
</script>

<style lang="scss" scoped>
.border-left-danger {
  border-left: 6px solid #dc3545 !important;
}
.border-left-secondary {
  border-left: 6px solid #6c757d !important;
}
.border-left-success {
  border-left: 6px solid #28a745 !important;
}
.text-dark-blue {
  color: #343c6a;
}
footer {
  position: absolute;
}

.text-secondary a {
  color: #172b46 !important;
  font-weight: bold;
}

.text-blue-shadow {
  color: #1a3d6b;
  text-shadow: 0px 0px 3px rgba(26, 71, 107, 0.4);
}

.text-blue-light {
  color: #617c9c;
}

.bg-blue-light-2 {
  background-color: #f9fafc;
}

.shadow-blue-sm {
  box-shadow: 0 0.125rem 0.25rem #e8ecf3 !important;
}
</style>
